/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Items as ItemsField } from '@micromag/fields';

import * as AppPropTypes from '../../lib/PropTypes';
import TrackingCodeField from './TrackingCode';

const propTypes = {
    value: AppPropTypes.trackingSettings,
    codeNewDefaultValue: AppPropTypes.trackingCode,
    codeItemsField: PropTypes.shape({}),
    onChange: PropTypes.func,
};

const defaultProps = {
    value: null,
    codeNewDefaultValue: {
        type: 'ga',
    },
    codeItemsField: {
        isHorizontal: true,
    },
    onChange: null,
};

const TrackingField = ({ value, onChange, codeNewDefaultValue, codeItemsField }) => {
    const onCodesChange = useCallback(
        (newCodesValue) => {
            const newValue = {
                ...value,
                codes: newCodesValue,
            };
            if (onChange !== null) {
                onChange(newValue);
            }
        },
        [value, onChange],
    );
    const getDefaultValue = useCallback(() => codeNewDefaultValue, [codeNewDefaultValue]);

    return (
        <div>
            <ItemsField
                value={value !== null ? value.codes || null : null}
                onChange={onCodesChange}
                noItemLabel={
                    <FormattedMessage
                        defaultMessage="No tracking code..."
                        description="No item label"
                    />
                }
                addItemLabel={
                    <FormattedMessage
                        defaultMessage="Add a tracking code"
                        description="Button label"
                    />
                }
                getDefaultValue={getDefaultValue}
                itemsField={codeItemsField}
                itemComponent={TrackingCodeField}
                withoutSort
            />
        </div>
    );
};

TrackingField.propTypes = propTypes;
TrackingField.defaultProps = defaultProps;

export default TrackingField;
